import { get } from "lodash"
import { SelectedPortfolio } from "helpers/types/instruments/selected"
import { IsoDate } from "helpers/types/dates"
import { CompositionByNode, getCompositionType } from "./composition"
import { OkReduxDataResult } from "model/state"
import { PositionSetMetadata } from "./types"

interface PortfolioData {
  portfolio: {
    name: string
    availableFrom: IsoDate
    alias: string
    intradayEnabled?: boolean
    betaInstrument?: {
      indexId?: string
      benchmarkId?: string
      securityId?: {
        internalId: string
        ticker: string
        mic: string
      }
      resource?: {
        // [TODO:TS]
        type: string
        alias: string
      }
    }
    fxHedgeEnabled: boolean
  }
  model: {
    simulation: {
      composition: [{
        referenceEquity: number
        compositionBy: CompositionByNode
      }]
    }
  }
}

export interface PortfolioMetadata extends PositionSetMetadata {
  type: "PORTFOLIO"
  fxHedgeEnabled: boolean
  // [TODO:TS] Find out type
  betaInstrument: unknown
  alias: string
  intradayEnabled: boolean
  // [TODO:TS] Optional or nullable?
  referenceEquity?: number
}

function getPortfolioQuery(isOpPro: boolean) {
  return `query ($portfolioId: String!, $modelId: String!, $currentDate: Date!, $segment: Segment) {
  portfolio (id: $portfolioId) {
    name
    availableFrom
    alias
    ${!isOpPro ? `
    intradayEnabled
    betaInstrument {
      indexId
      benchmarkId
      securityId {
        internalId
        ticker
        mic
      }
      resource {
        type
        alias
      }
    }` : ""}
    fxHedgeEnabled
  }
  model (id: $modelId) {
    simulation (positionSet: {
      type: PORTFOLIO,
      id: $portfolioId,
      segment: $segment
    }, from: $currentDate, to: $currentDate) {
      composition {
        referenceEquity
        compositionBy (groupBy: LONG_SHORT) {
          id
        }
      }
    }
  }
}`
}

function portfolioSelect(data: OkReduxDataResult<PortfolioData>, metadataDate: IsoDate): PortfolioMetadata {
  return {
    name: get(data, "data.portfolio.name"),
    earliestDate: get(data, "data.portfolio.availableFrom"),
    // [TODO:TS] Is this the best way to handle portfolio not found?
    // Probably better to return a different type?
    unavailable: !!get(data, "apiMessages.errors.0.message", "").match(/^Portfolio .* not found$/),
    fxHedgeEnabled: get(data, "data.portfolio.fxHedgeEnabled"),
    compositionType: getCompositionType(data),
    betaInstrument: get(data, "data.portfolio.betaInstrument"),
    alias: get(data, "data.portfolio.alias"),
    intradayEnabled: get(data, "data.portfolio.intradayEnabled", false),
    type: "PORTFOLIO",
    referenceEquity: get(data, "data.model.simulation.composition.0.referenceEquity"),
    latestDate: metadataDate,
  }
}

export function getPortfolioQueryDefinition(positionSet: SelectedPortfolio, modelId: string, metadataDate: IsoDate, isOpPro: boolean) {
  const variables = { portfolioId: positionSet.id, modelId, currentDate: metadataDate, segment: positionSet.segment }

  return {
    query: getPortfolioQuery(isOpPro),
    variables,
    queryKey: ["position-set", "metadata", "portfolio", variables],
    select: (data: OkReduxDataResult<PortfolioData>) => portfolioSelect(data, metadataDate),
  }
}
